// Full searchable radio details from the supplied 2023 statewide channel plan.
export default String.raw`45.1|136.0000|0.0|136.0000|.0.0|H|N|
46.1|151.25000|156.7|159.40500|000.0|H|N|
46.2|151.33250|156.7|159.27750|000.0|H|N|
46.3|151.35500|103.5|159.30000|000.0|H|N|
46.4|151.26500|103.5|159.33000|000.0|H|N|
46.5|151.40000|103.5|159.37500|000.0|H|N|
46.6|151.17500|192.8|151.17500|192.8|L|N|
46.7|151.19000|192.8|151.19000|192.8|L|N|
46.8|151.34000|192.8|151.34000|192.8|L|N|
46.9|151.46000|192.8|151.46000|192.8|L|N|
46.10|154.26500|156.7|154.26500|156.7|L|N|
46.11|154.29500|156.7|154.29500|156.7|L|N|
46.12|154.27250|156.7|154.27250|156.7|L|N|
46.13|154.28750|156.7|154.28750|156.7|L|N|
46.14|154.30250|156.7|154.30250|156.7|L|N|
46.15|151.22000|192.8|151.22000|192.8|L|N|
46.16|159.26250|192.8|159.26250|192.8|L|N|
46.17|159.36750|192.8|159.36750|192.8|L|N|
46.18|156.07500|156.7|156.07500|156.7|H|N|
46.19|155.75250|CSQ|155.75250|156.7|H|N|Alternate Air Amb Tac - Lemore
46.20|156.80000|000.0|156.80000|000.0|L|W|
46.21|157.10000|000.0|157.10000|000.0|L|W|
46.22|157.15000|000.0|157.15000|000.0|L|W|
46.23|170.46250|000.0|164.91250|000.0|H|N|
46.24|171.55000|000.0|164.15000|000.0|H|N|
46.25|168.26250|000.0|168.26250|000.0|H|N|Update Freq
46.26|163.71250|000.0|163.71250|000.0|H|N|Update Freq
46.27|166.55000|000.0|166.55000|000.0|L|N|
46.28|167.11250|000.0|167.11250|000.0|L|N|
46.29|168.23750|000.0|168.23750|000.0|L|N|
46.30|166.48750|000.0|167.07500|000.0|H|N|
46.31|166.37500|000.0|166.97500|000.0|H|N|
46.32|150.10000|103.5|148.86250|103.5|H|N|
46.33|163.53750|100.0|165.06250|000.0|H|N|
46.34|171.70000|000.0|171.70000|000.0|L|N|
46.35|173.20000|000.0|173.20000|000.0|L|N|
46.36|173.55000|000.0|173.55000|000.0|L|N|
46.37|143.71250|146.2|150.11250|000.0|H|N|Presidio Red Repeated
46.38|149.80000|146.2|149.80000|146.2|H|N|Presidio Gray Direct
46.39|148.85000|000.0|148.85000|000.0|L|N|
46.40|148.80000|000.0|148.80000|000.0|L|N|
46.41|155.80500|D445|153.90500|D445|H|N|Hollister Primary
46.42|155.52000|000.0|155.52000|162.2|L|N|
46.43|155.55000|000.0|155.55000|146.2|L|N|
46.44|151.02500|146.2|156.12000|146.2|H|N|
46.45|155.80500|D445|153.90500|D072|H|N|
46.46|151.02500|146.2|156.12000|110.9|H|N|Add Channel
46.47|153.78500|123.0|156.00000|123.0|H|N|
46.48|153.98000|192.8|154.40000|000.0|H|N|Tones 1 or 7
46.49|154.49000|179.9|158.37000|156.7|H|N|North Tree Fire
46.50|154.37000|D071|158.85000|D025|H|N|Mty Analog Fremont
46.51|154.01000|D051|158.85000|D025|H|N|Greenfield=Bridge W/Cmd 31
46.52|155.93250|D054|158.85000|D025|H|N|Mty Analog Huckleberry
46.53|154.17500|D047|158.85000|D025|H|N|Mty Analog TORO
46.54|153.95000|D071|158.85000|D025|H|N|
46.55|155.89500|D043|158.85000|D025|H|N|
46.56|154.20500|D051|158.85000|D025|H|N|Mty Analog Post Ranch
46.57|155.62500|D032|158.85000|D025|H|N|Mty Analog Williams/Calandra
46.58|155.83500|D073|158.85000|D025|H|N|Mty Analog Roberts (Crml Valley)
46.59|156.16500|D031|158.85000|D025|H|N|Mty Analog Lewis
46.60|155.40000|D026|158.85000|D025|H|N|Mty Analog Manzanita Park
46.61|152.24000|192.8|000.00000|000.0|H|N|
46.62|150.99500|192.8|000.00000|000.0|H|N|
46.63|154.20500|146.2|000.00000|000.0|H|N|Salinas Paging Channel
46.64|151.16000|146.2|155.95500|103.5|H|N|Old County Parks Toro
46.65|154.20500|146.2|155.95500|103.5|H|N|MoCo Command 33 Analog
46.66|153.89000|146.2|154.43000|110.9|H|N|MoCo Command 35 Analog
46.67|155.64000|156.7|155.64000|156.7|L|N|Moco Analog Tac
46.68|155.85000|156.7|155.85000|156.7|L|N|Moco Analog Tac
46.69|155.32500|000.0|155.32500|156.7|L|N|
46.70|153.86000|000.0|153.86000|156.7|L|N|
46.71|155.20500|000.0|155.20500|156.7|L|N|
46.72|155.35500|000.0|155.35500|156.7|L|N|
46.73|155.86500|D026N|158.74500|D026N|H|N|Countywide Interop
46.74|156.00000|146.2|154.10000|146.2|H|N|
46.75|153.98000|162.2|153.98000|162.2|L|N|
46.76|169.72500|000.0|165.45000|OST|H|N|Tone 1-Frmt/Tone 6-Wldct
46.77|168.30000|000.0|168.30000|000.0|L|N|Scene of Action
46.78|167.47500|000.0|167.47500|000.0|L|N|
46.79|168.63750|000.0|168.63750|000.0|L|N|
46.80|168.62500|000.0|168.62500|110.9|L|N|Emergency
47.1|153.78500|167.9|158.89500|167.9|H|N|Dispatch
47.2|155.88000|167.9|158.94000|131.8|H|N|Secondary Dispatch
47.3|151.47500|167.9|151.47500|167.9|L|N|KRN 2 Tactical
47.4|155.62500|167.9|158.85000|167.9|H|N|Command County Wide
47.5|151.45250|167.9|151.45250|167.9|L|N|KRN 3 Tactical
47.6|154.86000|167.9|158.82000|167.9|H|N|Primary Cmd Batt. 3 & 6
47.7|154.95000|167.9|154.95000|167.9|L|N|KRN 4 Tactical
47.8|151.10000|167.9|156.99000|167.9|H|N|Primary Command 1 & 7
47.9|154.08500|167.9|154.08500|167.9|L|N|KRN 5 Tactical
47.10|151.11500|167.9|156.22500|167.9|H|N|CMD, N Metro, Batt 6
47.11|156.16500|167.9|156.16500|167.9|L|N|KRN 6 Tactical
47.12|154.84500|167.9|156.19500|167.9|H|N|CMD, S Metro, Batt 4
47.13|151.12250|167.9|151.12250|167.9|L|N|KRN 7 Tactical
47.14|154.65000|167.9|154.65000|167.9|L|N|
47.15|155.70000|167.9|155.70000|167.9|L|N|KRN Tactical/Operations
47.16|154.78500|167.9|156.00000|167.9|H|N|Red Hill Rptr, Rosamond Area
47.17|155.13000|167.9|159.00000|167.9|H|N|Gorman Peak Repeater
47.18|153.99500|167.9|158.77500|167.9|H|N|Hwy 395 Rptr, Government Pk
47.19|154.07000|103.5|154.41500|103.5|H|N|
47.20|153.95000|103.5|154.37000|103.5|H|N|
47.21|154.17500|103.5|154.17500|103.5|L|N|
47.22|154.14500|103.5|154.14500|103.5|L|N|
47.23|156.07500|156.7|156.07500|156.7|H|N|
47.24|169.90000|000.0|165.70000|000.0|H|N|
47.25|170.55000|000.0|166.00000|000.0|H|N|
47.26|170.46250|000.0|164.91250|000.0|H|N|
47.27|168.26250|000.0|168.26250|000.0|H|N|
47.28|163.71250|000.0|163.71250|000.0|H|N|
47.29|154.28000|156.7|154.28000|156.7|H|N|
47.30|154.26500|156.7|154.26500|156.7|L|N|
47.31|154.29500|156.7|154.29500|156.7|L|N|
47.32|154.27250|156.7|154.27250|156.7|L|N|
47.33|154.28750|156.7|154.28750|156.7|L|N|
47.34|154.30250|156.7|154.30250|156.7|L|N|
47.35|169.77500|000.0|163.02500|000.0|H|N|
47.36|166.37500|000.0|166.97500|000.0|H|N|
47.37|168.05000|000.0|168.05000|000.0|L|N|
47.38|168.20000|000.0|168.20000|000.0|L|N|
47.39|168.60000|000.0|168.60000|000.0|L|N|
47.40|166.55000|000.0|166.55000|000.0|L|N|
47.41|167.11250|000.0|167.11250|000.0|L|N|
47.42|168.23750|000.0|168.23750|000.0|L|N|
47.43|155.16000|000.0|155.16000|85.4|L|N|Search and Rescue 2023
47.44|154.81500|210.7|159.16500|210.7|H|N|
47.45|151.04000|210.7|159.04500|210.7|H|N|
47.46|155.26500|210.7|158.99250|210.7|H|N|
47.47|154.81500|210.7|158.91000|210.7|H|N|
47.48|154.75500|210.7|158.87250|210.7|H|N|
47.49|151.13750|156.7|159.47250|136.5|H|N|Portable Repeater
47.50|151.22000|192.8|151.22000|192.8|L|N|
47.51|159.26250|192.8|159.26250|192.8|L|N|
47.52|159.36750|192.8|159.36750|192.8|L|N|
47.53|154.89000|167.9|154.89000|167.9|L|N|
47.54|167.47500|000.0|167.47500|000.0|L|N|
47.55|168.63750|000.0|168.63750|000.0|L|N|
47.56|168.62500|000.0|168.62500|110.9|L|N|Emergency
48.1|136.0000|0.0|136.0000|.0.0|H|N|
49.1|136.0000|0.0|136.0000|.0.0|H|N|
50.1|136.0000|0.0|136.0000|.0.0|H|N|`;
